import { t } from '@lingui/macro';

export const CURL_ERROR_CODES = {
    0: ' ',
    1: t`Unsupported Protocol`,
    2: t`Curl Failed Init`,
    3: t`Malformed URL`,
    4: t`Feature not built-in`,
    5: t`Couldn't resolve proxy`,
    6: t`Couldn't resolve host`,
    7: t`Failed to connect to host or proxy`,
    8: t`Weird FTP reply`,
    9: t`Access Denied`,
    10: t`FTP Accept Failed`,
    11: t`Weird FTP Password Reply`,
    12: t`FTP Accept Timeout`,
    13: t`Weird FTP PASV Reply`,
    14: t`Weird FTP 227 Format`,
    15: t`Internal failure looking up host`,
    17: t`Failure setting FTP Transfer Mode`,
    18: t`Response shorter than expected`,
    19: t`Couldn't retrieve file`,
    21: t`Quote Error`,
    22: t`HTTP Error code ≥ 400`,
    23: t`Error writing received data to a local file`,
    25: t`Failed starting file upload`,
    26: t`Failure reading local file`,
    27: t`Curl Out of Memory`,
    28: t`Operation Timeout`,
    30: t`FTP Port command returned error`,
    31: t`FTP REST command returned error`,
    33: t`Server does not support or accept range requests`,
    34: t`CURL HTTP POST Error`,
    35: t`SSL Connect Error`,
    36: t`Download cannot continue`,
    37: t`File could not be opened`,
    38: t`LDAP cannot bind`,
    39: t`LDAP Search Failed`,
    41: t`Function not found (zlib)`,
    42: t`Aborted by callback`,
    43: t`Internal Error`,
    45: t`Interface could not be used`,
    47: t`Too many redirects`,
    48: t`Unknown Option`,
    49: t`Illegally formatted Telnet option string`,
    51: t`Remote server SSL Cert deemed not OK`,
    52: t`Nothing was returned from the server`,
    53: t`Specified crypto engine not found`,
    54: t`Failed setting the SSL crypto engine as default`,
    55: t`Failed sending network data`,
    56: t`Failure receiving network data`,
    58: t`Problem with the local client certificate`,
    59: t`Couldn't use specified cipher`,
    60: t`Peer certificate cannot be authenticated with known CA certificates`,
    61: t`Unrecognized transfer encoding`,
    62: t`Invalid LDAP URL`,
    63: t`Maximum file size exceeded`,
    64: t`Requested FTP SSL level failed`,
    65: t`Rewinding operation failed`,
    66: t`Initiating the SSL Engine failed`,
    67: t`The remote server denied login`,
    68: t`File not found on TFTP server`,
    69: t`Permission problem on TFTP server`,
    70: t`Out of disk space on the server`,
    71: t`Illegal TFTP operation`,
    72: t`Unknown TFTP transfer ID`,
    73: t`File already exists and will not be overwritten`,
    74: t`This error should never be returned by a properly functioning TFTP server`,
    75: t`Character conversion failed`,
    76: t`Caller must register conversion callbacks`,
    77: t`Problem with reading the SSL CA cert`,
    78: t`The resource referenced in the URL does not exist`,
    79: t`An unspecified error occurred during the SSH services`,
    80: t`Failed to shut down the SSL connection`,
    81: t`Socket is not ready`,
    82: t`Failed to load CRL file `,
    83: t`Issuer check failed`,
    84: t`The FTP server does not understand the PRET command`,
    85: t`Mismatch of RTSP CSeq numbers`,
    86: t`Mismatch of RTSP Session Identifiers`,
    87: t`Unable to parse FTP file list`,
    88: t`Chunk callback reported error`,
    200: t`HTML did not contain the specified content`,
    201: t`HTML contained content it should not have`,
    202: t`HTML did not contain the specified content and HTML contained content it should not have`,
    203: t`Unexpected authentication failure`,
    204: t`Request led to unknown redirect URL`,
    205: t`Redirect loop detected`,
    206: t`Too many redirects (50 followed)`,
    207: t`Server hostname does not match with peer certificate hostname(s)`,
    208: t`Proxy server authentication failed`,
    209: t`Proxy server connect timeout`,
    210: t`HTTP response code did not match the expected response code`,
    211: t`Connect timeout`,
    212: t`Web test timeout`,
};

export const HTTP_RESPONSE_CODES = {
    100: t`Continue`,
    101: t`Switching Protocols`,
    102: t`Processing`,
    200: t`OK`,
    201: t`Created`,
    202: t`Accepted`,
    203: t`Non-Authoritative Information`,
    204: t`No Content`,
    205: t`Reset Content`,
    206: t`Partial Content`,
    207: t`Multi-Status`,
    208: t`Already Reported`,
    226: t`IM Used`,
    300: t`Multiple Choices`,
    301: t`Moved Permanently`,
    302: t`Found`,
    303: t`See Other`,
    304: t`Not Modified`,
    305: t`Use Proxy`,
    307: t`Temporary Redirect`,
    308: t`Permanent Redirect`,
    400: t`Bad Request`,
    401: t`Unauthorized`,
    402: t`Payment Required`,
    403: t`Forbidden`,
    404: t`Not Found`,
    405: t`Method Not Allowed`,
    406: t`Not Acceptable`,
    407: t`Proxy Authentication Required`,
    408: t`Request Timeout`,
    409: t`Conflict`,
    410: t`Gone`,
    411: t`Length Required`,
    412: t`Precondition Failed`,
    413: t`Payload Too Large`,
    414: t`URI Too Long`,
    415: t`Unsupported Media Type`,
    416: t`Requested Range Not Satisfiable`,
    417: t`Expectation Failed`,
    422: t`Unprocessable Entity`,
    423: t`Locked`,
    424: t`Failed Dependency`,
    425: t`Unassigned`,
    426: t`Upgrade Required`,
    427: t`Unassigned`,
    428: t`Precondition Required`,
    429: t`Too Many Requests`,
    430: t`Unassigned`,
    431: t`Request Header Fields Too Large`,
    500: t`Internal Server Error`,
    501: t`Not Implemented`,
    502: t`Bad Gateway`,
    503: t`Service Unavailable`,
    504: t`Gateway Timeout`,
    505: t`HTTP Version Not Supported`,
    506: t`Variant Also Negotiates (Experimental)`,
    507: t`Insufficient Storage`,
    508: t`Loop Detected`,
    509: t`Unassigned`,
    510: t`Not Extended`,
    511: t`Network Authentication Required`,
    '-203': t`Unexpected authentication failure`,
    '-45': t`Interface could not be used`,
};

export const VOIP_ERROR_CODES = {
    0: t`Success`,
    1: t`Unregistered`,
    2: t`Register wav failure`,
    3: t`Call not answered`,
    4: t`Place call failure`,
    5: t`Call unhandled state`,
    6: t`No media present`,
    7: t`Early disconnect`,
    8: t`Unknown call type`,
    9: t`Not an nPoint`,
    10: t`Wrong nPoint`,
    11: t`Line Busy`,
    12: t`Forwarded to Voicemail`,
    13: t`Line not found`,
    14: t`Default network unavailable`,
    15: t`Wireless network unavailable`,
    16: t`Failed Callee DNS Resolve`,
    17: t`Invalid Callee URI`,
    18: t`Invalid Phone Number`,
    19: t`Canceled - Global nPoint hourly transmit budget exceeded`,
};

export const VOIP_SIP_STATUS_CODES = {
    400: t`Bad Request`,
    401: t`Unauthorized`,
    403: t`Forbidden`,
    404: t`Not Found`,
    405: t`Method Not Allowed`,
    406: t`Not Acceptable`,
    407: t`Proxy Authentication Required`,
    408: t`Request Timeout`,
    410: t`Gone`,
    412: t`Conditional Request Failed`,
    413: t`Request Entity Too Large`,
    414: t`Request-URI Too Long`,
    415: t`Unsupported Media Type`,
    416: t`Unsupported URI Scheme`,
    417: t`Unknown Resource-Priority`,
    420: t`Bad Extension`,
    421: t`Extension Required`,
    422: t`Session Interval Too Small`,
    423: t`Interval Too Brief`,
    424: t`Bad Location Information`,
    428: t`Use Identity Header`,
    429: t`Provide Referrer Identity`,
    433: t`Anonymity Disallowed`,
    436: t`Bad Identity-Info`,
    437: t`Unsupported Certificate`,
    438: t`Invalid Identity Header`,
    439: t`First Hop Lacks Outbound Support`,
    470: t`Consent Needed`,
    480: t`Temporarily Unavailable`,
    481: t`Call/Transaction Does Not Exist`,
    482: t`Loop Detected`,
    483: t`Too Many Hops`,
    484: t`Address Incomplete`,
    485: t`Ambiguous`,
    486: t`Busy Here`,
    487: t`Request Terminated`,
    488: t`Not Acceptable Here`,
    489: t`Bad Event`,
    491: t`Request Pending`,
    493: t`Undecipherable`,
    494: t`Security Agreement Required`,
    500: t`Server Internal Error`,
    501: t`Not Implemented`,
    502: t`Bad Gateway`,
    503: t`Service Unavailable`,
    504: t`Server Time-out`,
    505: t`Version Not Supported`,
    513: t`Message Too Large`,
    580: t`Precondition Failure`,
    600: t`Busy Everywhere`,
    603: t`Decline`,
    604: t`Does Not Exist Anywhere`,
    606: t`Not Acceptable`,
};

export const VOIP_CODECS = {
    0: t`G.711U/PCMU`,
    2: t`G.726 32K`,
    3: t`GSM`,
    8: t`G.711A/PCMA`,
    9: t`G.722`,
    18: t`G.729`,
};
